let filters = document.querySelector('.filter-holder');
let filtersOpen = document.querySelector('.js-open-filters');
let filtersClose = document.querySelectorAll('.js-close-filters');
let toggleFilters = document.querySelectorAll('legend');

for (let i = 0; i < toggleFilters.length; i++) {
    toggleFilters[i].addEventListener('click', function () {
        this.parentNode.classList.toggle('open');
    });
}

filtersOpen.addEventListener('click', openFilters);

for (let i = 0; i < filtersClose.length; i++) {
    filtersClose[i].addEventListener('click', closeFilters);
}

function openFilters() {
    filters.classList.add('open');
    document.body.classList.add('filters-open');
}

function closeFilters() {
    filters.classList.remove('open');
    document.body.classList.remove('filters-open');
}

let tagCheckbox = document.querySelectorAll('#filterform .checkbox input');
for (let i = 0; i < tagCheckbox.length; i++) {
    tagCheckbox[i].addEventListener('change', filterChanged);
}

var parts = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
if (parts.indexOf('http://') != 0 || parts.indexOf('https://') != 0) {
    parts.forEach(function (item, index) {
        var param = item.split('=');
        var key = param[0];
        var value = decodeURIComponent(param[1]).split(',');
        for (var j = 0; j < value.length; ++j) {
            var filterOptions = document.getElementsByName(key);
            for (var i = 0; i < filterOptions.length; i++) {
                value[j].replace(/\s/g, '');
                if (filterOptions[i].value === value[j]) {
                    filterOptions[i].setAttribute('checked', true)
                }
            }
        }
    });
}

function filterChanged() {
    var arrayChecked = []
    var checkboxes = document.querySelectorAll('#filterform input[type=checkbox]:checked');
    for (var i = 0; i < checkboxes.length; i++) {
        var key = checkboxes[i].name;
        var info = checkboxes[i].value;
        var temp = {};

        if (arrayChecked[key]) {
            arrayChecked[key].push(info);
        } else {
            arrayChecked[key] = [info];
        }
    }

    var url = document.querySelector('#filterform').getAttribute('data-url');
    for (var key in arrayChecked) {
        url += (url.indexOf('?') >= 0) ? '&' : '?';
        url += key + '=' + arrayChecked[key].join(',');
    }
    window.location.href = url;
}

//Function to get the elements position outside of his parent.
function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
        top: rect.top + window.scrollY
    };
}

//Set filter button fixed when reaches top of the screen
var stickyButton = getOffset(filtersOpen).top;

function fixedFilterButton() {
    if ((window.pageYOffset + 70) > stickyButton) {
        filtersOpen.classList.add('is-sticky');
    } else {
        filtersOpen.classList.remove('is-sticky');
    }
}

window.onscroll = function () {
    fixedFilterButton();
};
